import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import TableRowAction from 'components/common/TableRowAction';
import { weTableDataForProject } from 'data/weraise-data/sponsored-list-data';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';

const ProjectProgressList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'milestone',
      Header: 'Milestone ',
      cellProps: {
        className: 'py-2 fw-medium'
      },
      Cell: rowData => {
        const { ref, project } = rowData.row.original;
        return <Link to={`/project/details/${ref}`}>{project}</Link>;
      }
    },
    {
      accessor: 'manager',
      Header: 'Manager',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'start_date',
      Header: 'Started Date',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'due_date',
      Header: 'Due Date',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'total_funding',
      Header: 'Funding',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        return (
          <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
            {rowData.row.original.status}
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'oid',
      Header: '',
      cellProps: {
        className: 'text-end fw-medium py-2'
      },
      disableSortBy: true,
      Cell: rowData => {
        const { id } = rowData.row;

        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  const content = (
    <IconButton
      variant="falcon-default"
      icon="project-diagram"
      iconClassName="text-primary"
      className="me-2"
      size="sm"
      transform="shrink-3"
      onClick={() => navigate('/project/create_project')}
    >
      <span className="text-primary d-none d-lg-inline-block ms-2">
        Create Milestone
      </span>
    </IconButton>
  );

  return (
    <Row>
      <Col md={12} xxl={12} className="h-md-100">
        <CustomAdvanceTable
          data={weTableDataForProject}
          columns={columns}
          perPage={10}
          showTablePagination
          title={`Project #${id}`}
          showSearchInput
          searchInputPlaceHolder="Search"
          addNew={false}
          content={content}
        />
      </Col>
    </Row>
  );
};

export default ProjectProgressList;
